import {
  createStyles,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";
import { Control, Controller } from "react-hook-form";
import { IdentifierMapping } from "../../constants";

const useStyles = makeStyles((theme) =>
  createStyles({
    form: {
      width: "100%", // Fix IE 11 issue.
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 250,
    },
    streetWrapper: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    street: {
      marginRight: 30,
    },
  })
);
interface Props {
  control: Control<any>;
}

export function IdentifierSelector({ control }: Props) {
  const classes = useStyles();

  return (
    <Controller
      name="identifier"
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControl className={classes.formControl}>
          <InputLabel id="select-identifier-label">
            Identifizierungstyp
          </InputLabel>
          <Select
            labelId="select-identifier-label"
            id="select-identifier-select"
            value={value}
            onChange={onChange}
          >
            <MenuItem value={"insurance"}>
              {IdentifierMapping["insurance"]}
            </MenuItem>
            <MenuItem value={"passport"}>
              {IdentifierMapping["passport"]}
            </MenuItem>
            <MenuItem value={"identity_card"}>
              {IdentifierMapping["identity_card"]}
            </MenuItem>
          </Select>
        </FormControl>
      )}
    />
  );
}

export default IdentifierSelector;
